import { FeApi } from '@/api/fe-api';
import type { GuaranteedValue } from '@/warranty-v3/entities/guaranteed-value';

export function guaranteedValueMapper(
  data: FeApi.GuaranteedValue,
): GuaranteedValue {
  return {
    base: data.base,
    penalty: data.penalty,
    effective: data.effective,
  };
}
